import React from 'react'
import RenderVideo from './RenderVideo'
import ScrollBtn from './ScrollBtn'

const ProductsHero = ({
  whereToScroll,
  title,
  heading,
  description,
  MHeroVideo,
  THeroVideo,
  DHeroVideo,
  scrollBtnStyles = '',
  id = '',
  textWrapperClassList = '',
}) => {
  return (
    <div className='hero-video relative overflow-hidden'>
      <RenderVideo
        id={id}
        videoM={MHeroVideo}
        videoT={THeroVideo}
        videoD={DHeroVideo}
        classList={
          'max-w-[1920px] lg:left-1/2 lg:-translate-x-1/2 absolute object-cover h-full w-screen -z-[1] overflow-hidden'
        }
      />
      <div className={`lg:pb-0 lg:justify-center md:pb-[70px] container h-full absolute left-1/2 -translate-x-1/2  z-[1] flex flex-col justify-end pb-[65px] text-black-100 ${textWrapperClassList}`}>
        <p
          className='md:text-3xl md:mb-[17px] text-xl mb-[13px]'
          data-aos='fade-up'
          data-aos-duration='500'
          data-aos-easing='ease-in-out'
        >
          {title}
        </p>
        <h1
          className='lg:text-6xl md:max-w-[610px] md:text-7xl md:mb-[12px] text-3xl mb-[16px] max-w-[280px]'
          data-aos='fade-up'
          data-aos-duration='500'
          data-aos-easing='ease-in-out'
        >
          {heading}
        </h1>
        <p
          className='lg:max-w-[500px] md:max-w-[655px] text-lg max-w-[310px]'
          data-aos='fade-up'
          data-aos-duration='500'
          data-aos-easing='ease-in-out'
        >
          {description}
        </p>
        {/* For scroll button give (and set if needed) next section id */}
        <div
          className={`${scrollBtnStyles} hidden absolute bottom-0 left-1/2 -translate-x-1/2`}
        >
          <ScrollBtn to={whereToScroll} />
        </div>
      </div>
    </div>
  )
}

export default ProductsHero
